import React from "react";
import {
  Box,
  CircularProgress,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Alert,
  Button,
} from "@mui/material";
import { useFetchTicketCreationQuery } from "../../Redux/apis/ApiSlice";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

const AllTickets = () => {
  const [tickets, setTickets] = React.useState([]);
  const { data, isLoading, isError, error } = useFetchTicketCreationQuery();
  const navigate = useNavigate();
  React.useEffect(() => {
    if (Array.isArray(data)) {
      setTickets(data);
    } else if (Array.isArray(data?.data)) {
      setTickets(data.data);
    } else {
      setTickets([]);
    }
  }, [data]);

  const handleViewClick = (ticket) => {
    const selected = ticket.tickets[0].ticketTemplate;

    const ticketData = {
      id: ticket.tickets[0].ticketTemplate,
      title: ticket?.eventName || "ROAD TRIP",
      organizer: ticket?.organizationName || "Taylor Reilly",
      date:
        dayjs(ticket?.startDateTime || "July 29, 2024").format("MM/DD/YYYY") ||
        "July 29, 2024",
      time:
        dayjs(ticket?.startDateTime || "02:20 PM").format("hh:mm A") ||
        "02:20 PM",
      location: ticket?.location || "123 Anywhere st., Any City",
      position: "Organizer",
      qrCode: "",
      bgColor: "",

      // Corrected to match expected data shape
      ticketCategories:
        ticket?.tickets?.flatMap(
          (ticketItem) =>
            ticketItem?.subTickets?.map((subTicket) => ({
              typeName: "Ticket", // You can customize if you have specific names
              price: subTicket.price,
              quantity: subTicket.quantity,
            })) || []
        ) || [],
    };
    navigate("/ticket-display", {
      state: { eventData: ticketData, ticketType: selected },
    });
  };
  //
  return (
    <Box p={3}>
     

      {/* Loading State */}
      {isLoading && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="50vh"
        >
          <CircularProgress />
        </Box>
      )}

      {/* Error State */}
      {isError && (
        <Alert severity="error" sx={{ my: 2 }}>
          {error?.data?.message ||
            "Failed to fetch tickets. Please try again later."}
        </Alert>
      )}

      {/* Data State */}
      {tickets && tickets.length > 0 ? (
        <TableContainer component={Paper} elevation={3}>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                <TableCell sx={{ fontWeight: "bold" }}>Event Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Location</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Organization</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Date</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tickets.map((ticket) => (
                <TableRow key={ticket.customTicketId}>
                  <TableCell>{ticket.eventName}</TableCell>
                  <TableCell>{ticket.location}</TableCell>
                  <TableCell>{ticket.organizationName}</TableCell>
                  <TableCell>
                    {new Date(ticket.startDateTime).toLocaleDateString(
                      "en-US",
                      {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      }
                    )}
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleViewClick(ticket)}
                    >
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        // No Data Message
        !isLoading &&
        !isError && (
          <Typography variant="body1" color="text.secondary" mt={2}>
            No tickets available.
          </Typography>
        )
      )}
    </Box>
  );
};

export default AllTickets;
